<script>
	// NPM Modules
	import { tick } from 'svelte';
	import collect from 'collect.js';
	// Stores
	import ParentMarketStore from '@/Stores/Sport/ParentMarketStore';
	import SportStore from '@/Stores/Sport/SportStore';
	// Partials
	import ListParentMarkets from '@/Partials/Sport/Manage/ParentMarkets/_List.svelte';
	import CreateParentMarket from '@/Partials/Sport/Manage/ParentMarkets/_Create.svelte';
	import UpdateParentMarket from '@/Partials/Sport/Manage/ParentMarkets/_Update.svelte';
	// Components
	import Switch from '@/Components/Switch.svelte';

	export let sport;

	let showCreateParentMarket = false;
	let showUpdateParentMarket = false;
	let selectedParentMarket;
	let onlyShowManual = false;

	let parentMarkets;

	$: sport && $SportStore && getParentMarkets();
	$: filteredParentMarkets = parentMarkets && (onlyShowManual || !onlyShowManual) && filterParentMarkets(parentMarkets);

	function getParentMarkets() {
		ParentMarketStore.getParentMarketsForSport(sport.id).then(() => {
			parentMarkets = $ParentMarketStore.sortBy('name') ?? null;
		});
	}

	async function openCreateParentMarket() {
		showCreateParentMarket = true;
		await tick();
		window.scrollTo(0, 0);
	}

	async function openUpdateParentMarket() {
		showUpdateParentMarket = true;
		await tick();
		window.scrollTo(0, 0);
	}

	function filterParentMarkets(parentMarketsToBeFiltered) {
		let parentMarketsToFilter = parentMarketsToBeFiltered ?? collect();

		if (onlyShowManual) {
			parentMarketsToFilter = parentMarketsToFilter.where('is_manual', true);
		}

		return parentMarketsToFilter.all();
	}
</script>

{#if showCreateParentMarket}
	<CreateParentMarket bind:sport bind:open={showCreateParentMarket} on:created={() => getParentMarkets()} />
{:else if showUpdateParentMarket}
	<UpdateParentMarket
		bind:open={showUpdateParentMarket}
		bind:parentMarket={selectedParentMarket}
		on:updated={() => getParentMarkets()}
	/>
{/if}

<div>
	<div class="flex items-end justify-between w-full">
		<div class="flex flex-row">
			<Switch bind:checked={onlyShowManual} className="-mt-1 ml-6" />
			<div class="ml-3">Show manual parent markets only</div>
		</div>
		<button on:click={() => openCreateParentMarket()} class="btn btn-primary"> Create parent market</button>
	</div>
	{#if parentMarkets}
		<ListParentMarkets
			bind:parentMarkets={filteredParentMarkets}
			bind:sport
			bind:selectedParentMarket
			on:selected={() => openUpdateParentMarket()}
		/>
	{/if}
</div>
